if (!customElements.get('bb-ss-product-videos')) {
  customElements.define('bb-ss-product-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.mount();
    }
    mount() {
      const id = this.dataset.sectionId;
      const source = this.querySelector('template[id="ss-product-video-'+id+'"]');
      const modalSource = this.querySelector('template[id="ss-product-video-modal-'+id+'"]');
      const info = document.querySelector('main .product-info');
      if (!source || !modalSource || !info || !window.Swiper) return;
      const position = this.dataset.position || 'below_buy';
      let target = this.dataset.metafieldOnly === 'true' ? null : document.getElementById('ss-product-videos');
      if (!target) target = info.querySelector(position.includes('title') ? '.product-info__title' : position.includes('description') ? '.product-info__description' : '.product-info__buy-buttons');
      this.gallery = source.content.firstElementChild.cloneNode(true);
      this.modal = modalSource.content.firstElementChild.cloneNode(true);
      if (target) target.insertAdjacentElement(position.startsWith('below_') ? 'afterend' : 'beforebegin', this.gallery);
      else info.append(this.gallery);
      document.body.append(this.modal);
      const signal = this.controller.signal;
      const select = (root, prefix) => root.querySelector('.'+prefix+'-'+id);
      const previews = [...this.gallery.querySelectorAll('.video-slide-'+id)];
      const slides = [...this.modal.querySelectorAll('.video-modal-slide-'+id)];
      this.previews = previews;
      this.slides = slides;
      this.slider = new Swiper(select(this.gallery,'video-slider'), {slidesPerView:'auto',speed:300,watchOverflow:true,navigation:{nextEl:select(this.gallery,'video-btn-next'),prevEl:select(this.gallery,'video-btn-prev')}});
      this.player = new Swiper(select(this.modal,'video-modal-slider'), {slidesPerView:1,speed:300,spaceBetween:20,watchOverflow:true,navigation:{nextEl:select(this.modal,'video-modal-next'),prevEl:select(this.modal,'video-modal-prev')}});
      this.player.on('slideChange',()=>this.updatePlayback());
      previews.forEach((preview,index)=>{
        preview.setAttribute('role','button');preview.tabIndex=0;
        preview.setAttribute('aria-label',this.dataset.playLabel+' '+(index+1));
        const open=()=>{
          this.opener=preview;this.overflow=document.body.style.overflow;
          document.body.style.overflow='hidden';this.modal.showModal();this.modal.classList.add('active');
          this.player.update();this.player.slideTo(index,0);this.updatePlayback();
          select(this.modal,'video-modal-close').focus();
        };
        preview.addEventListener('click',open,{signal});
        preview.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();open();}},{signal});
      });
      select(this.modal,'video-modal-close').setAttribute('aria-label',this.dataset.closeLabel);
      select(this.modal,'video-modal-close').addEventListener('click',()=>this.modal.close(),{signal});
      this.modal.addEventListener('click',e=>{if(e.target===this.modal)this.modal.close();},{signal});
      this.modal.addEventListener('close',()=>{
        this.modal.classList.remove('active');this.updatePlayback();document.body.style.overflow=this.overflow||'';
        this.opener?.focus({preventScroll:true});
      },{signal});
      slides.forEach(slide=>{
        const toggle=select(slide,'video-modal-action');
        const video=slide.querySelector('video');
        if (!toggle || !video) return;
        toggle.setAttribute('role','button');toggle.tabIndex=0;
        const label=()=>{toggle.setAttribute('aria-label',video.muted?this.dataset.soundOn:this.dataset.soundOff);toggle.setAttribute('aria-pressed',String(!video.muted));toggle.classList.toggle('active',!video.muted);};
        video.muted=true;label();
        const sound=()=>{video.muted=!video.muted;label();};
        toggle.addEventListener('click',sound,{signal});
        toggle.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();sound();}},{signal});
      });
      this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        const video=entry.target;video.muted=true;video.loop=true;
        if(entry.isIntersecting && !document.hidden && !this.modal.open)video.play().catch(()=>{});else video.pause();
      }),{threshold:.1});
      this.gallery.querySelectorAll('video').forEach(video=>{video.muted=true;video.loop=true;this.observer.observe(video);});
      document.addEventListener('visibilitychange',()=>this.updatePlayback(),{signal});
      this.modal.querySelectorAll('button').forEach(button=>button.type='button');
      for(const [prefix,label] of [['video-modal-prev',this.dataset.previous],['video-btn-prev',this.dataset.previous],['video-modal-next',this.dataset.next],['video-btn-next',this.dataset.next]]){
        const button=select(prefix.includes('modal')?this.modal:this.gallery,prefix);if(button)button.setAttribute('aria-label',label);
      }
    }
    updatePlayback() {
      const active=this.modal.open && !document.hidden;
      this.slides.forEach((slide,index)=>{
        const video=slide.querySelector('video');const frame=slide.querySelector('iframe');
        if(video){if(active&&index===this.player.activeIndex)video.play().catch(()=>{});else video.pause();}
        if(frame){const src=active&&index===this.player.activeIndex?frame.dataset.src2:frame.dataset.src;if(src&&frame.getAttribute('src')!==src)frame.src=src;}
      });
      this.gallery.querySelectorAll('video').forEach(video=>{
        const rect=video.getBoundingClientRect();video.muted=true;
        if(!active&&!document.hidden&&rect.bottom>0&&rect.top<innerHeight)video.play().catch(()=>{});else video.pause();
      });
    }
    disconnectedCallback() {
      if(this.modal?.open){this.modal.close();document.body.style.overflow=this.overflow||'';}
      this.controller?.abort();this.observer?.disconnect();this.slider?.destroy();this.player?.destroy();
      this.gallery?.remove();this.modal?.remove();this.controller=null;
    }
  });
}

